// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kEYV","toggle":"styles_toggle__35NfK","preview":"styles_preview__jfYHp"};